import React, { useContext } from 'react';
import { BookOpen } from 'phosphor-react';
import { TutorialProvider } from '../TutorialPopup/context';
import { HelpPopupDispatchContext, HelpPopupProvider } from '../HelpPopup/context';
import ButtonOutline from '../../sharedComponents/Button/ButtonOutline';
import HelpPopup from '../HelpPopup';
import TutorialPopup from '../TutorialPopup';
import CollectionTutorialPopup from '../CollectionTutorialPopup';
import { CollectionTutorialProvider } from '../CollectionTutorialPopup/context';

function GuidesAndResourcesBase() {
  const sethelpPopupOpen = useContext(HelpPopupDispatchContext);
  return (
    <TutorialProvider>
      <CollectionTutorialProvider>
        <>
          <ButtonOutline onClick={() => sethelpPopupOpen(true)}>
            <BookOpen size={16} className="mr-2" />
            Guide and Resources
          </ButtonOutline>
          <HelpPopup />
          <TutorialPopup />
          <CollectionTutorialPopup />
        </>
      </CollectionTutorialProvider>
    </TutorialProvider>
  );
}

export function GuidesAndResources() {
  return (
    <HelpPopupProvider>
      <GuidesAndResourcesBase />
    </HelpPopupProvider>
  );
}
